import Switch from '@mui/material/Switch';

/**
 * MUI Switch for role forms — works with react-hook-form Controller `field` spread.
 * Maps RHF `value` to Switch `checked` when `checked` is not provided.
 */
export function RoleSwitch({
  checked,
  value,
  onChange,
  onBlur,
  name,
  disabled,
  inputRef,
  ref,
  ...rest
}) {
  const isChecked = checked !== undefined ? checked : Boolean(value);

  return (
    <Switch
      size="small"
      checked={isChecked}
      onChange={onChange}
      onBlur={onBlur}
      name={name}
      disabled={disabled}
      inputRef={inputRef ?? ref}
      {...rest}
    />
  );
}
